<template>
  <v-container
    :class="busy ? 'fill-height' : ''"
    id="mandate-payment-redirect"
    style="width: 67%"
  >
    <v-row v-if="busy">
      <v-col class="text-center">
        <v-progress-circular
          :size="150"
          :width="6"
          class="mb-4"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div class="display-1">
          {{ $t("message.payment_is_being_processed") }}
        </div>
      </v-col>
    </v-row>

    <v-row v-else justify="center">
      <v-col class="mt-12">
        <MaterialCardV2
          :icon="getCardIcon"
          color="primary"
          :title="getCardTitle"
        >
          <v-row class="pa-5" align="center">
            <v-col v-if="result.external_payment_state === 'paid'">
              <div class="display-1">
                {{
                  isBankAccountChange
                    ? $t("label.subscription_remains_active")
                    : $t("label.subscription_activated")
                }}
              </div>
            </v-col>
            <v-col v-else>
              <div class="display-1">
                {{
                  $t("message.payment_not_processed", {
                    email: $store.state.config.email
                  })
                }}
              </div>
            </v-col>
            <v-col align="center" class="hidden-sm-and-down" cols="6">
              <v-icon size="100">{{ getCardIcon }}</v-icon>
            </v-col>
          </v-row>

          <v-divider class="mt-6"></v-divider>
          <v-row>
            <v-col>
              <v-btn
                class="no-text-transform display-1"
                color="grey darken-3"
                text
                :to="{ name: $store.state.config.main_page }"
              >
                {{ $t("label.return_to_main_page") }}
                <v-icon class="ml-2 lighten-5" small>mdi-home</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </MaterialCardV2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCardV2 from "@/components/views/MaterialCardV2.vue";
import { sleep } from "@/helpers/Sleep";

export default {
  name: "MandatePaymentRedirect",
  components: { MaterialCardV2 },
  async mounted() {
    if (!this.$store.state.subscription.payment_id) {
      await this.$router.push({ name: this.$store.state.config.main_page });
      return;
    }

    const MAX_ATTEMPTS = 10;
    const MAX_DELAY = 30000;
    const MAX_DURATION = 30000;
    const DELAY_INCREASE = 500;
    let delay = 1000;
    const startTime = Date.now();

    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
      await sleep(delay);
      delay = Math.min(delay + DELAY_INCREASE * attempt, MAX_DELAY);

      try {
        const response = await this.$store.dispatch("subscription/getResult");
        const data = response.data;

        if (
          data.external_payment_state === "paid" ||
          attempt === MAX_ATTEMPTS - 1 ||
          Date.now() - startTime > MAX_DURATION
        ) {
          this.result = data;
          this.busy = false;
          return;
        }
      } catch {
        this.result = { external_payment_state: "failed" };
        this.busy = false;
        return;
      }
    }
  },
  data() {
    return {
      result: {},
      busy: true
    };
  },
  computed: {
    isBankAccountChange() {
      return this.$store.state.subscription.is_bank_account_change;
    },
    getCardIcon() {
      return this.result.external_payment_state === "paid"
        ? "mdi-check"
        : "mdi-alert-circle-outline";
    },
    getCardTitle() {
      if (this.result.external_payment_state !== "paid") {
        return this.$t("message.payment_completed_error");
      }
      return this.isBankAccountChange
        ? this.$t("message.bank_account_change_completed_success")
        : this.$t("message.mandate_request_completed_success");
    }
  }
};
</script>

<style scoped></style>
